import css from "styled-jsx/css";

export default css`
  .width-50 {
    width: 48%;
  }

  .width-55 {
    width: 55%;
  }

  .title {
    width: 40%;
    height: 40px;
    border-radius: 8px;
    margin-bottom: 1rem;
    margin-top: 1rem;
  }

  .banners {
    display: flex;
    flex-wrap: nowrap;
    justify-content: space-between;
    .banner {
      height: 24rem;
      border-radius: 8px;
      margin-bottom: 1rem;
    }
  }
`;
